import {Component, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
    selector: 'app-customer',
    template: `
        <router-outlet></router-outlet>`,
    styleUrls: ['./customer.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class CustomerComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/customer/customer.component.ts